import { whereOperators } from '@/lib/query-parameter/filter';
import { searchFieldTypeOptions, workerStatusOptions, } from '@/constants/workerManagementList';
const getters = {
    getterCheckedWorkerList: () => [],
    getterPageSize: ({ filterOption }) => Number(filterOption.pageSizeType),
    getterPageSizeType: ({ filterOption }) => filterOption.pageSizeType,
    getterWorkerList: ({ workerList }) => workerList ?? [],
    getterPaginationData: ({ paginationData }) => {
        const { pageNumber, pages, } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
    getterWorkerTotalLength: ({ paginationData }) => paginationData.total,
    getterSearchFieldTypeParam: ({ filterOption }) => {
        const [NAME, HUB_EMPLOYEE_NUMBER, PHONE, CAR_NUMBER,] = searchFieldTypeOptions;
        const { value, field } = filterOption.searchWord;
        return {
            [NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: NAME.field,
                    value,
                },
            ],
            [HUB_EMPLOYEE_NUMBER.value]: [
                {
                    condition: whereOperators.like,
                    field: HUB_EMPLOYEE_NUMBER.field,
                    value,
                },
            ],
            [PHONE.value]: [
                {
                    condition: whereOperators.like,
                    field: PHONE.field,
                    value,
                },
            ],
            [CAR_NUMBER.value]: [
                {
                    condition: whereOperators.like,
                    field: CAR_NUMBER.field,
                    value,
                },
            ],
        }[field];
    },
    getterWorkerStatus: ({ filterOption }) => {
        const [ALL, OK, STOP, LEAVE, DELETE,] = workerStatusOptions;
        const { workerStatus } = filterOption;
        return {
            [ALL.value]: [
                {
                    condition: whereOperators.notEquals,
                    field: DELETE.field,
                    value: DELETE.value,
                },
            ],
            [OK.value]: [
                {
                    condition: whereOperators.equals,
                    field: OK.field,
                    value: OK.value,
                },
            ],
            [STOP.value]: [
                {
                    condition: whereOperators.equals,
                    field: STOP.field,
                    value: STOP.value,
                },
            ],
            [LEAVE.value]: [
                {
                    condition: whereOperators.equals,
                    field: LEAVE.field,
                    value: LEAVE.value,
                },
            ],
        }[workerStatus];
    },
    getterTypeValue: ({ filterOption }) => filterOption.type,
    getterSalaryTypeValue: ({ filterOption }) => filterOption.salaryType,
    getterWorkerStatusValue: ({ filterOption }) => filterOption.workerStatus,
    getterSearchValue: ({ filterOption }) => filterOption.searchWord.value,
    getterSearchField: ({ filterOption }) => filterOption.searchWord.field,
};
export default getters;
